import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-dialog',
  templateUrl: './update-dialog.component.html',
  styleUrls: ['./update-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateDialogComponent implements OnInit {
  constructor(public dialogRef: MatDialogRef<UpdateDialogComponent>) { }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() { }

  close() {
    this.dialogRef.close(false);
  }

  update() {
    this.dialogRef.close(true);
  }
}
